import { Tune } from '@mui/icons-material';
import React, { RefObject, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AllTestsDrawer } from '../../../components/AllTestsDrawer/AllTestsDrawer.tsx';
import { Bids } from '../../../components/Bids/Bids.tsx';
import { Cards } from '../../../components/Cards/Cards.tsx';
import { ComplexSequence } from '../../../components/Sequence/ComplexSequence.tsx';
import { ExamDifficultyLevelView, ExamView } from '../../../graphql/types.gen.ts';
import { useGame } from '../useGame.ts';
import { DummyTable } from './DummyTable.tsx';

interface IGameTestProps {
	id?: string;
	forLesson?: boolean;
	onSubmit?: () => void;
	containerRef?: RefObject<HTMLDivElement | null>;
	scrollToBottom?: () => void;
	nextTest?: () => void;
}

export const GameTest = ({ id, forLesson, onSubmit, containerRef, scrollToBottom, nextTest }: IGameTestProps) => {
	const [isAllTestsDrawerOpen, setIsAllTestsDrawerOpen] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();
	const [drawerFilters, setDrawerFilters] = useState<{ tags: string[]; difficultyLevels: ExamDifficultyLevelView[] }>(
		{
			tags: [],
			difficultyLevels: [],
		}
	);
	const {
		testLoading,
		chosenGroup,
		handleResult,
		randomTest,
		userBids,
		handleRecentBids,
		recentBids,
		drawTest,
		handleUserBids,
		lastUserBid,
		bestAnswers,
		southCards,
		result,
		handleNextTest,
		repeatTest,
		drawTestById,
		resultSaveVersion,
	} = useGame(scrollToBottom, id, onSubmit, drawerFilters, forLesson);

	useEffect(() => {
		const nextTestId = id || randomTest?.id;
		if (!nextTestId) return;
		if (searchParams.get('testId') === nextTestId) return;

		const nextParams = new URLSearchParams(searchParams);
		nextParams.set('testId', nextTestId);
		setSearchParams(nextParams, { replace: true });
	}, [id, randomTest?.id, searchParams, setSearchParams]);

	return (
		<>
			{!forLesson && (
				<button className="button__filters" onClick={() => setIsAllTestsDrawerOpen(true)}>
					<Tune />
				</button>
			)}
			<div className="game__container" ref={containerRef}>
				{!randomTest && <DummyTable />}
				{!randomTest && !testLoading && 'Nie znaleziono testu'}
				{!!randomTest && (
					<>
						{!forLesson && (
							<AllTestsDrawer
								drawTestById={drawTestById}
								drawTest={drawTest}
								chosenGroup={chosenGroup}
								isOpened={isAllTestsDrawerOpen}
								onClose={() => setIsAllTestsDrawerOpen(false)}
								filters={drawerFilters}
								onFiltersChange={setDrawerFilters}
								resultSaveVersion={resultSaveVersion}
							/>
						)}
						<div className="game__seq">
							<ComplexSequence
								result={result}
								groupCode={chosenGroup}
								handleResult={handleResult}
								drawnTest={randomTest}
								userBids={userBids}
								handleRecentBids={handleRecentBids}
							/>
							<Bids
								result={result}
								drawnTest={randomTest as ExamView}
								handleUserBids={handleUserBids}
								handleResult={handleResult}
								userBid={lastUserBid}
								bestAnswers={bestAnswers}
								drawTest={drawTest}
								repeatTest={repeatTest}
								nextTest={forLesson ? nextTest : nextTest ?? handleNextTest}
								recentBids={recentBids}
								forLesson={forLesson}
								currentTestId={randomTest.id}
							/>
						</div>
						<Cards cards={southCards || Array.from({ length: 13 })} showPc={!!result} />
					</>
				)}
			</div>
		</>
	);
};
